export default "__VITE_ASSET__BbQHyW4j__"